import { Injectable } from '@angular/core';
import { ApiService } from '@core/auth/auth.service';
import { config } from '@core/interfaces/api_baseurl';
import { SupportType } from '@page/ticketing/helper/ticket.interface';
import { BehaviorSubject, of, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestServiceService {

  _supportType = new BehaviorSubject<SupportType | null>(null);

  constructor(private _ApiService: ApiService) { }

  getSupportType() {
    if (this._supportType.getValue()) {
      return of(this._supportType.getValue());
    }
    return this._ApiService.post(config.ticketing.raise.support_type).pipe(
      switchMap((res: any) => {
        this._supportType.next(res)
        return of(res);
      }))
  }
}
